import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@whelk/hooks/src/useRouter';
import { RootState } from '@whelk/store';
import { useSidebar, IconButton } from '@whelk/components';
import { isNative } from '@whelk/const/src/env';
import { HOME_URL } from '@whelk/const/src/routerUrl';
import { MinimaxLogo } from '@whelk/assets/src/web/brand-icons';
import { nativeBridge } from '@whelk/utils/src/bridge/callNativeBridge';

import UserInfo from '../UserInfo';
import ThemeToggle from '../ThemeToggle';
import SidebarLogin from '../SidebarLogin';
import SidebarHistory from '../SidebarHistory';
import { SidebarCloseIcon, SidebarSettingIcon, SideBarToggleIcon } from './icon';
import { HISTORY_LIST_TYPE } from '@whelk/store/slices/historyListSlice';

const SidebarContent = () => {
  const { open, setOpen } = useSidebar();
  const { t } = useTranslation();
  const nav = useRouter();
  const isLogin = useSelector((state: RootState) => state.user.isLogin);
  const { isLoading } = useSelector((state: RootState) => state.history[HISTORY_LIST_TYPE.ALL]);
  const initUserLoading = useSelector((state: RootState) => state.user.initUserLoading);
  const [navLoading, setNavLoading] = useState(true);

  const goSetting = () => {
    closeSidebar();
    nativeBridge.callNative({
      methodName: 'jumpPage',
      params: {
        openUrl: 'yingshi://setting',
      },
    });
  };

  useEffect(() => {
    if (!isLoading && !initUserLoading) {
      setNavLoading(false);
    }
  }, [isLoading, initUserLoading]);

  const handleLogoClick = () => {
    nav.push(HOME_URL);
  };

  const closeSidebar = () => {
    setOpen(false);
  };

  if (initUserLoading || navLoading) {
    const skeletonStyle = 'rounded-[10px] bg-col_bg14 ';
    return (
      <div className='flex flex-col gap-3 p-4'>
        <div className={`${skeletonStyle} mb-2 h-[30px] w-[110px] `} />
        <div className={`${skeletonStyle} h-[40px] w-full`} />
        <div className='flex flex-col items-end gap-3 pl-[30px]'>
          <div className={`${skeletonStyle} h-[32px] w-full opacity-90`} />
          <div className={`${skeletonStyle} h-[32px] w-full opacity-80`} />
          <div className={`${skeletonStyle} h-[32px] w-full opacity-70`} />
          <div className={`${skeletonStyle} h-[32px] w-full opacity-60`} />
        </div>
      </div>
    );
  }
  return (
    <div className='flex h-full w-full min-w-[var(--left-model-width)] flex-1 flex-col justify-between'>
      <div className='hidden h-[60px] items-center justify-between px-4 md:flex'>
        <button className='text-col_accent04' onClick={handleLogoClick}>
          <MinimaxLogo height={28} width={120} />
        </button>
        <IconButton
          tip={open ? t('collapse_side_bar') : ''}
          className='md:hover:bg-col_bg14  h-[32px] w-[32px]'
          placement='right'
          onClick={closeSidebar}
        >
          <SideBarToggleIcon />
        </IconButton>
      </div>
      <div className='flex h-[60px] items-center justify-between py-2 pl-[14px] pr-[16px] md:hidden'>
        {/* 用户信息 */}
        <div onClick={closeSidebar}>
          <UserInfo />
        </div>
        <div className='flex items-center gap-2'>
          {isNative ? (
            <div onClick={goSetting}>
              <SidebarSettingIcon />
            </div>
          ) : (
            <div onClick={closeSidebar}>
              <ThemeToggle />
            </div>
          )}
          <div
            onClick={closeSidebar}
            className='bg-col_bg14 flex h-6 w-6 items-center justify-center rounded-full'
          >
            <SidebarCloseIcon />
          </div>
        </div>
      </div>

      {isLogin ? (
        <SidebarHistory />
      ) : (
        <>
          <div className='flex flex-1 items-center justify-center md:hidden'>
            <SidebarLogin />
          </div>
          <div className='hidden w-full flex-1 flex-col justify-between md:flex'>
            <SidebarHistory />
          </div>
        </>
      )}
    </div>
  );
};

export default SidebarContent;
